/**
 * The SUPPORT-1634 routes, one place. The scenario layer matches on these same builders, so a
 * fixture can never answer a URL the client does not call, and the contract probe can ask dev for
 * exactly the routes that still have a mock.
 */
const studio = (artistId: string) => `/api/studio/v1/artists/${artistId}`;

export const offerFunnelRoutes = {
  offers: (artistId: string) => `${studio(artistId)}/offers`,
  offer: (artistId: string, offerId: string) => `${studio(artistId)}/offers/${offerId}`,
  offerUsages: (artistId: string, offerId: string) => `${studio(artistId)}/offers/${offerId}/usages`,
  offerEditions: (artistId: string, offerId: string) => `${studio(artistId)}/offers/${offerId}/editions`,
  campaignOffer: (artistId: string, campaignId: string) => `${studio(artistId)}/lead-campaigns/${campaignId}/offer`,
  automationOfferChecks: (artistId: string, automationId: string) =>
    `${studio(artistId)}/automations/${automationId}/offer-checks`,
  leadFunnels: (artistId: string) => `${studio(artistId)}/lead-funnels`,
  // Existing legacy route. The staff/leader campaign PUT; the offer change sends offer_id alone.
  leadCampaign: (artistId: string, campaignId: string) => `/web/studio/artists/${artistId}/lead-campaigns/${campaignId}`,
} as const;

export type OfferFunnelRouteName = keyof typeof offerFunnelRoutes;
